// src/components/admin/shared/AiSettingsModal.js
import React, { useState } from 'react';
import { X } from 'lucide-react';

const AiSettingsModal = ({ isOpen, onClose, onApply, defaultSettings }) => {
  const [settings, setSettings] = useState(defaultSettings || {
    contentLength: 'medium',
    tone: 'professional',
    targetAudience: 'general',
    customInstructions: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onApply(settings);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">Advanced AI Settings</h3>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Content Length
            </label>
            <select
              name="contentLength"
              value={settings.contentLength}
              onChange={handleChange}
              className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="short">Short (250-500 words)</option>
              <option value="medium">Medium (500-1000 words)</option>
              <option value="long">Long (1000-1500 words)</option>
              <option value="comprehensive">Comprehensive (1500+ words)</option>
            </select>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Tone
            </label>
            <select
              name="tone"
              value={settings.tone}
              onChange={handleChange}
              className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="professional">Professional</option>
              <option value="casual">Casual</option>
              <option value="technical">Technical</option>
              <option value="persuasive">Persuasive</option>
              <option value="educational">Educational</option>
            </select>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Target Audience
            </label>
            <select
              name="targetAudience"
              value={settings.targetAudience}
              onChange={handleChange}
              className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="general">General</option>
              <option value="business">Business Professionals</option>
              <option value="technical">Technical Audience</option>
              <option value="beginners">Beginners</option>
              <option value="experts">Industry Experts</option>
            </select>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Custom Instructions
            </label>
            <textarea
              name="customInstructions"
              value={settings.customInstructions}
              onChange={handleChange}
              placeholder="Add any specific instructions for the AI (e.g., include case studies, avoid jargon, focus on benefits)"
              rows="4"
              className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
            ></textarea>
          </div>

          <div className="flex justify-end space-x-3 mt-5">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
            >
              Apply Settings
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AiSettingsModal;